














import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "terms-and-conditions-provider": () =>
      import(
        "@/components/app/admin/settings/billing/termsAndConditions/termsAndConditionsProvider.vue"
      ),
    "terms-and-conditions-form": () =>
      import(
        "@/components/app/admin/settings/billing/termsAndConditions/termsAndConditionsForm.vue"
      )
  }
})
export default class SettingsTermsAndConditionsView extends Vue {}
